import crypto from "crypto-js";

export function generateEncryptedKey() {
  const iv = "1MSkHyTtRmWseef4";

  try {
    const key = crypto.lib.WordArray.random(32);
    const timestamp = Date.now();
    const dataPayload = { appkey: timestamp };
    const appkey = JSON.stringify(dataPayload);

    const encrypted = crypto.AES.encrypt(appkey, key, {
      iv: crypto.enc.Utf8.parse(iv),
      mode: crypto.mode.CBC,
    });

    const encryptedHex = encrypted.ciphertext.toString();
    const keyHash = key.toString();

    return {
      hash: keyHash,
      sek: encryptedHex,
      appkey,
    };
  } catch (error) {
    console.error("", error);
    return null;
  }
}

export function generateEncryptedKeyBody(body: any) {
  const iv = "1MSkHyTtRmWseef4";

  try {
    const key = crypto.lib.WordArray.random(32);
    const dataPayload = {
      ...body,
      appkey: Date.now(),
    };

    const encrypted = crypto.AES.encrypt(JSON.stringify(dataPayload), key, {
      iv: crypto.enc.Utf8.parse(iv),
      mode: crypto.mode.CBC,
    });

    return {
      hash: key.toString(),
      sek: encrypted.ciphertext.toString(),
    };
  } catch (error) {
    console.error("", error);
    return null;
  }
}
